import type {DataAuditWritebackType} from 'src/components/data-audit/types';


export const DATA_AUDIT_AUDIT_TABLE_PAGE_SIZE = 10;

export const DATA_AUDIT_MAX_LOOKBACK_DAYS = 90;

export const DATA_AUDIT_API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const DATA_AUDIT_WRITEBACK_BREAKDOWN_ORDER: Array<DataAuditWritebackType> =
  ['nwb', 'fwb', 'owb'];

export const DATA_AUDIT_BY_ATS_ID_ARRAY_KEYS = [
  'responses',
  'writebacks',
  'entries',
  'nodes',
  'data',
  'results',
] as const;

export const DATA_AUDIT_BY_ATS_ID_AUDIT_ARRAY_KEYS = [
  'audits',
  'auditResponses',
  'auditDetails',
  'auditEntries',
  'children',
  'responses',
] as const;

export const SUPPORTED_FIELD_NONE_VALUE = 'None';
